import React, { createContext, useContext, useState } from 'react';
import { ContactTypingInfo, AgentMessage } from './types';

interface ChatContextType {
  selectedChat: string | null;
  setSelectedChat: React.Dispatch<React.SetStateAction<string | null>>;

  chatMessages: connect.ChatEventData[];
  setChatMessages: React.Dispatch<React.SetStateAction<connect.ChatEventData[]>>;

  previousChatMessagesByContact: Record<string, connect.ChatEventData[]>;
  setPreviousChatMessagesByContact: React.Dispatch<React.SetStateAction<Record<string, connect.ChatEventData[]>>>;

  agentMessage: AgentMessage[];
  setAgentMessage: React.Dispatch<React.SetStateAction<AgentMessage[]>>;

  chatContacts: string[];
  setChatContacts: React.Dispatch<React.SetStateAction<string[]>>;

  isTyping: ContactTypingInfo[];
  setIsTyping: React.Dispatch<React.SetStateAction<ContactTypingInfo[]>>;

  unreadMessages: { [key: string]: number };
  setUnreadMessages: React.Dispatch<React.SetStateAction<{ [key: string]: number }>>;
}

const ChatContext = createContext<ChatContextType>({
  selectedChat: null,
  setSelectedChat: () => {},
  chatMessages: [],
  setChatMessages: () => {},
  previousChatMessagesByContact: {},
  setPreviousChatMessagesByContact: () => {},
  agentMessage: [],
  setAgentMessage: () => {},
  chatContacts: [],
  setChatContacts: () => {},
  isTyping: [],
  setIsTyping: () => {},
  unreadMessages: {},
  setUnreadMessages: () => {}
});

export const useChatContext = (): ChatContextType => useContext(ChatContext);

interface ChatProviderProps {
  children: React.ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState<string | null>(null);
  const [chatMessages, setChatMessages] = useState<connect.ChatEventData[]>([]);
  const [previousChatMessagesByContact, setPreviousChatMessagesByContact] = useState<
    Record<string, connect.ChatEventData[]>
  >({});
  const [agentMessage, setAgentMessage] = useState<AgentMessage[]>([]);
  const [chatContacts, setChatContacts] = useState<string[]>([]);
  const [isTyping, setIsTyping] = useState<ContactTypingInfo[]>([]);
  const [unreadMessages, setUnreadMessages] = useState<{ [key: string]: number }>({});

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        chatMessages,
        setChatMessages,
        previousChatMessagesByContact,
        setPreviousChatMessagesByContact,
        agentMessage,
        setAgentMessage,
        chatContacts,
        setChatContacts,
        isTyping,
        setIsTyping,
        unreadMessages,
        setUnreadMessages
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
